import {
    GET_SUBSCRIPTIONS_BY_DOMAIN_REQUEST,
    GET_SUBSCRIPTIONS_BY_DOMAIN_SUCCESS,
    GET_SUBSCRIPTIONS_BY_DOMAIN_FAILED,
} from '../../actions/subscription/get-subscriptions-by-domain'

import {
    UPGRADE_SUBSCRIPTION_REQUEST,
    UPGRADE_SUBSCRIPTION_SUCCESS,
    UPGRADE_SUBSCRIPTION_FAILED,
} from '../../actions/subscription/upgrade-subscription'

const initialState = {
    domainSubscriptions: null,
    requesting: false,
    error: null,
    upgradedSubscription: null
}

export const subscriptionsByDomain = (state = initialState, action) => {
    switch (action.type) {
        case GET_SUBSCRIPTIONS_BY_DOMAIN_REQUEST:
            return Object.assign({}, state, {
                requesting: true,
                domainSubscriptions: null,
                error: null,
            })
        case GET_SUBSCRIPTIONS_BY_DOMAIN_SUCCESS:
            return Object.assign({}, state, {
                domainSubscriptions: action.payload.data.payload,
                requesting: false,
                error: action.error,
            })
        case GET_SUBSCRIPTIONS_BY_DOMAIN_FAILED:
            return Object.assign({}, state, {
                domainSubscriptions: null,
                requesting: false,
                error: null,
            })
        case UPGRADE_SUBSCRIPTION_REQUEST:
            return Object.assign({}, state, {
                requesting: true,
                error: null,
            })
        case UPGRADE_SUBSCRIPTION_SUCCESS:
            return Object.assign({}, state, {
                requesting: false,
                error: null,
                upgradedSubscription: action.payload.data.payload._id
            })
        case UPGRADE_SUBSCRIPTION_FAILED:
            return Object.assign({}, state, {
                requesting: false,
                error: action.error,
            })
        default:
            return state
    }

}



// WEBPACK FOOTER //
// ./src/redux/reducers/subscription/subscriptions-by-domain.js